/**
 * Whether this browser can share a screen at all.
 *
 * `getDisplayMedia` is missing on every iPhone and on Android Chrome, and it
 * is missing outside a secure context. The control was offered anyway, so a
 * patient on a phone had a button that opened nothing — and, because sharing
 * is how a therapist puts a worksheet up, the failure read as the session
 * being broken rather than as the phone not doing this.
 *
 * The same rule the background effect already follows: offering something
 * that cannot work is worse than not offering it.
 */
export function canShareScreen(): boolean {
    return (
        typeof navigator !== "undefined" &&
        typeof navigator.mediaDevices?.getDisplayMedia === "function"
    );
}
